export const getOptimizelyEndUserId = function () {
  if (typeof window.optimizely !== 'undefined' && typeof window.optimizely.get === 'function') {
    return window.optimizely.get('visitor_id').randomId;
  }
  return '';
};

export const getOptimizelyCohorts = function () {
  if (typeof window.optimizely !== 'undefined' && typeof window.optimizely.get === 'function') {
    const variations = optimizely.get('state').getVariationMap();
    let buckets = {};

    for (let key in variations) {
      buckets[key] = variations[key].id;
    }

    buckets = JSON.stringify(buckets);
    return buckets;
  }
  return '';
};

export const getOptimizelySegments = function () {
  if (typeof window.optimizely !== 'undefined' && typeof window.optimizely.get === 'function') {
    const custom = optimizely.get('visitor').custom;
    let segments = {};

    for (var key in custom) {
      // Sometimes it's encoded and has extra quotes
      var val = decodeURIComponent(custom[key].value);
      val = val.replace(/^"(.*)"$/, '$1');
      segments[custom[key].id] = val;
    }

    segments = JSON.stringify(segments);
    return segments;
  }
  return '';
};

// Get experiments+cohort that the user is enrolled in formatted for consumption by MEP Provisioning Provider
// Returns (possibly empty) array of objects with experimentId and cohortId properties
export const getAllOptimizelyCohortsAsObjects = function () {
  if (typeof window.optimizely !== 'undefined' && typeof window.optimizely.get === 'function') {
    const variations = optimizely.get('state').getVariationMap();

    return Object.keys(variations).map( key => ({ experimentId: key, cohortId: variations[key].id}));
  }
  return [];
};

// Extend getAllOptimizelyCohortsAsObjects function to return null if array is empty
export const getMappedOptimizelyCohorts = function () {
  const cohorts = getAllOptimizelyCohortsAsObjects();
  return cohorts.length ? cohorts : null;
};
